import { action, observable } from "mobx";
import { api, api_adm } from "../../api";
import { ITipi } from "../../model";
import { toast } from "react-toastify";

export class _TipiStore {
  obs = observable({
    tipis: [] as ITipi[],
    total: 0 as number,
  })


  constructor() {
  }

  @action
  async load(page: number): Promise<void> {
    try {
      let resp = await api.get(`/api/tipi-index/${page}`);

      this.obs.tipis = [];
      this.obs.total = resp.data.total;
      this.obs.tipis = resp.data.itens
    } catch (ex) {
      toast.error("Erro ao carregar Tipi, tente novamente mais tarde.", {});
    }
  }

  /**
 * Salva a edição de um registro TIPI via API administrativa.
 *
 * A função:
 * - Envia os dados do objeto `tipi` para o endpoint `/api/admin/tipi/update` via **POST**.
 * - Se a resposta da API contiver `{ ok: true }`:
 *   - Exibe um `toast.success` confirmando a edição.
 *   - Retorna `true`.
 * - Caso contrário:
 *   - Exibe um `toast.error` com a mensagem vinda da API (`resp.data.msg`).
 *   - Retorna `false`.
 * - Em caso de exceção (falha de rede, erro inesperado), captura o erro e mostra `toast.error`.
 *
 * ## Efeitos colaterais
 * - Realiza chamada HTTP para a API administrativa (`api_adm.post`).
 * - Exibe notificações de sucesso ou erro via **toast**.
 *
 * @async
 * @param {Object} tipi Objeto TIPI a ser salvo.
 *
 * @returns {Promise<boolean>} `true` se o TIPI foi salvo com sucesso, `false` caso contrário.
 */

  async handleSaveEdit(tipi) {
    try {
      let resp = await api_adm.post('/api/admin/tipi/update', tipi);

      if (resp.data.ok) {
        toast.success('Tipi Editado!', {});

      return true

      } else {
        toast.error(`Não foi possível salvar tipi: ${resp.data.msg}`, {});
      }

    } catch (ex) {
      toast.error(`Não foi possível salvar tipi: ${ex}`, {});
    }

    return false

  }

  async busca(filter: string, paged) {
    try {
      let params = {
        filter: filter,
        page: paged,
        limit: 15
      }
      let resp = await api.post(`/api/filtra-tipi`, params);

      this.obs.tipis = [];
      this.obs.total = resp.data.total;
      this.obs.tipis = resp.data.itens
    } catch (ex) {
      toast.error("Erro ao filtrar Tipi, tente novamente mais tarde.", {});
    }
  }
}

export const TipiStore = new _TipiStore();
